import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';

var SelectionConfirmPanel = createReactClass({
  propTypes: {
    selectedItems: PropTypes.number,
    confirmSelection: PropTypes.func,
  },

  getDefaultProps: function() {
    return {
      selectedItems: 0,
    };
  },

  render: function() {
    let disabled = this.props.selectedItems === 0;
    return (
      <div className="confirm-panel">
        <button
          type="button"
          className="btn btn-default pull-right confirm"
          disabled={disabled}
          onClick={this.props.confirmSelection}
        >
          OK ({this.props.selectedItems})
        </button>
      </div>
    );
  },
});

export default SelectionConfirmPanel;



// WEBPACK FOOTER //
// ./src/js/app/cm/components/mediaBrowser/SelectionConfirmPanel.jsx